export const RESOURCE_NAME = "Resource Name";
export const TAG = "Tag";
export const RESOURCE_DESCRIPTION = "Resource Description";
export const LINK = "Link";
export const RESOURCE_TYPE = "Resource Type";

export const VALIDATION_RULES = {
  resourceName: {
    required: true,
    maxLength: 80,
  },
  tag: {
    required: true,
  },
  description: {
    required: true,
    maxLength: 160,
  },
  link: {
    required: true,
    maxLength: 4000,
  },
  resourceType: {
    required: true,
  }
};

export const ERROR_INITIAL = {
  resourceName: { isError: false, message: "" },
  tag: { isError: false, message: "" },
  description: { isError: false, message: "" },
  link: { isError: false, message: "" },
  resourceType: { isError: false, message: "" },
};

export const MAX_FILE_SIZE = 15 * 1024 * 1024; // 15 MB
export const ALLOWED_EXTENSIONS = [
  "pdf",
  "pptx",
  "ppt",
  "docx",
  "doc",
] as const;
export const UPLOAD_DURATION = 2000; // 2 seconds
export const UPDATE_INTERVAL = 50; // 50ms
export const TAG_OPTIONS = [
  { label: "Marketing & Enablement", value: "marketing_enablement" },
  { label: "Success Cases", value: "success_cases" },
  { label: "Delivery", value: "delivery" },
  { label: "Learning", value: "learning" },
  { label: "Related Materials", value: "related_materials" },
];
export const MAX_LENGTH_RESOURCE_NAME = 80;
export const MAX_LENGTH_RESOURCE_DESCRIPTION = 160;
export const MAX_LENGTH_LINK = 4000;
